import React from 'react';
import clamp from 'lodash/clamp';

import defaultUseSearchParam from './useSearchParam';

const usePagination = ({
  initialTotal = 0,
  initialPage = 1,
  initialPerPage = 10,
  useSearchParam = defaultUseSearchParam,
} = {}) => {
  const [total, setTotal] = React.useState(initialTotal);
  const [page, setPage] = useSearchParam({ key: 'page' });
  const [perPage, setPerPage] = useSearchParam({ key: 'perPage' });

  const handleChange = React.useCallback(
    (_page, _perPage) => {
      const newPageSize = Math.max(1, _perPage);
      const totalPages = Math.ceil(total / newPageSize);
      const toPage = clamp(_page, 1, totalPages);
      setPage(toPage === initialPage ? undefined : toPage);
      setPerPage(newPageSize === initialPerPage ? undefined : newPageSize);
    },
    [setPage, setPerPage, initialPage, initialPerPage, total],
  );

  const reset = React.useCallback(() => {
    handleChange(initialPage, initialPerPage);
  }, [initialPage, initialPerPage, handleChange]);

  return {
    page: +page || initialPage,
    perPage: +perPage || initialPerPage,
    total,
    setTotal,
    reset,
    // TODO: rename in components
    handleChange,
  };
};

export default usePagination;
